import { useEffect, useState } from 'react';
import type { HeaderResponse } from '../../pages/api/types';
import { getAnonymously } from '../api';
import { AppStore } from './AppStore';
import HeaderCategoryBar from './HeaderCategoryBar';
import StickyHeader from './StickyHeader';

const initialHeaderData: HeaderResponse = {
    primaryNavigation: [],
    headerCategories: [],
};

export default function Header({ data: initialData }: { data?: HeaderResponse }) {
    const [data, setData] = useState(initialData ?? initialHeaderData);

    useEffect(() => {
        if (initialData) return;
        getAnonymously<HeaderResponse>('/api/header').then(setData);
    }, [initialData]);

    return (
        <>
            <AppStore />
            <StickyHeader links={data.primaryNavigation} />
            <HeaderCategoryBar links={data.headerCategories} />
        </>
    );
}
